import { useState, useEffect } from 'react';

/**
 * Hook für automatisches Speichern/Laden von State in LocalStorage
 */
export const useLocalStorage = (key, initialValue) => {
  // Lade initialen Wert aus LocalStorage oder verwende initialValue
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.warn(`Error loading ${key} from localStorage:`, error);
      return initialValue;
    }
  });

  // Speichere automatisch bei jeder Änderung
  const setValue = (value) => {
    try {
      // Erlaube sowohl Funktionen als auch Werte
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      
      // Speichere in LocalStorage
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      console.warn(`Error saving ${key} to localStorage:`, error);
    }
  };

  return [storedValue, setValue];
};

